import "../../chunk-5WRI5ZAA.js";

// src/livePreview/eventManager/livePreviewEventManager.constant.ts
var LIVE_PREVIEW_POST_MESSAGE_EVENTS = {
  INIT: "init",
  ON_CHANGE: "client-data-send",
  HISTORY: "history",
  CHECK_ENTRY_PAGE: "check-entry-page",
  URL_CHANGE: "url-change",
  VARIANT_PATCH: "variant-patch-update"
};
var LIVE_PREVIEW_CHANNEL_ID = "live-preview";
export {
  LIVE_PREVIEW_CHANNEL_ID,
  LIVE_PREVIEW_POST_MESSAGE_EVENTS
};
//# sourceMappingURL=livePreviewEventManager.constant.js.map